import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { HomeScreenComponent } from './home-screen/home-screen.component';
import { PublicRoutingModule } from './public-routing.module';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { OnlineApplicationOneComponent } from './online-application-one/online-application-one.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';



@NgModule({
  declarations: [HeaderComponent, FooterComponent, PublicLayoutComponent, HomeScreenComponent, LoginComponent, RegisterComponent, OnlineApplicationOneComponent, ForgotPasswordComponent, ResetPasswordComponent],
  imports: [
    CommonModule,
    PublicRoutingModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class PublicModule { }
